// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   TextField,
//   Button,
// } from "@mui/material";
// import axios from "axios";
// import {

//   VAVE,

//   IL1APPROVEBYPD,
// } from "../../../Pages/AppConstant";
// function AlertDialogForm(request ) {
//   const [inputValue, setInputValue] = useState("");
//   const [openAlert, setOpenAlert] = useState(false);

// const handleSubmit = (accepted) => {

//    if (inputValue.trim() === "") {
//       setOpenAlert(true);
//     } else {
//       alert("Accepted with input: " + inputValue);
//        return;
//     }

//   const formData = new FormData();

//   formData.append("il1_pd_approve_id", localStorage.getItem("empid"));
//   formData.append("il1_pd_approve", localStorage.getItem("emailid"));

//   formData.append("idea", request.idea);
//   formData.append("ideaids", request.id);
//   formData.append("il1_pd_comment", inputValue);
//   formData.append("il1_pd_status", accepted);

//   try {
//     const response = axios.post(
//        VAVE + IL1APPROVEBYPD,
//       formData,

//     );

//     alert("Idea submitted successfully!");

//      Setisloading(false)
//   } catch (error) {
//      Setisloading(false)
//     console.error("Upload failed:", error);
//     alert("Upload failed. Please try again.");
//   }
// };

//   return (
//     <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
//       {/* <div className="col-md-4"> */}
//         <label htmlFor="comment">Comment*</label>
//         <input
//           type="text"
//           id="proposedIdea"
//           className="form-control"
//           placeholder="Enter comment"
//           fullWidth
//         required
//         value={inputValue}
//         onChange={(e) => setInputValue(e.target.value)}
//         />
//       {/* </div> */}

//       <div style={{ marginTop: "20px", textAlign: "right" }}>
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleSubmit("accepted")}
//           style={{ marginRight: "10px" }}
//         >
//           Accept
//         </Button>
//         <Button variant="outlined" color="error" onClick={handleSubmit("rejected")}>
//           Reject
//         </Button>
//       </div>

//       {/* Alert Dialog */}
//       <Dialog open={openAlert} onClose={handleCloseAlert}>
//         <DialogTitle>Missing Required Field</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Please enter a comment before accepting. This field is mandatory.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseAlert} autoFocus>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default AlertDialogForm;

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
import { toWords } from "number-to-words";
import {
  VAVE,
  IL1APPROVEBYPD,
  IL1APPROVEBYSOURCING,
  GETMODEL,
} from "../../../../Pages/AppConstant";
import { sourcingEmpIds } from "../../switch_on_userlist";

function AlertDialogForm({ request, setRefreshApi }) {
  const [inputValue, setInputValue] = useState("");
  const [savingsValue, setSavingsValue] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modelTempList, setModelTempList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState("");
  const [selectedModel, setselectedModel] = useState("");
  const [testingRequired, setTestingRequired] = useState("");
  const [isNegotiation, setIsNegotiation] = useState("");
  const [variantList, setVariantList] = useState([]);
  const [subVariantList, setSubVariantList] = useState([]);

  const [selectedSubVariant, setSelectedSubVariant] = useState([]);

  const handleCloseAlert = () => setOpenAlert(false);

  const fetchAllData = () => {
    axios({
      method: "get",
      url: VAVE + GETMODEL,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        const data = res.data.data;
        setModelTempList(data);

        const uniqueModels = data.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.model === obj.model)
        );
        setModelList(uniqueModels);
      })
      .catch((error) => {
        console.error("Error fetching model data:", error);
      });
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  // Handle model selection
  useEffect(() => {
    if (selectedModel) {
      const variants = modelTempList
        .filter((item) => item.model === selectedModel)
        .map((item) => item.variant)
        .filter((value, index, self) => self.indexOf(value) === index);

      setVariantList(variants);
      setSelectedVariant("");
      setSubVariantList([]);
      setSelectedSubVariant("");
    } else {
      setVariantList([]);
      setSelectedVariant("");
      setSubVariantList([]);
      setSelectedSubVariant("");
    }
  }, [selectedModel, modelTempList]);

  // Handle variant selection
  useEffect(() => {
    if (selectedModel && selectedVariant) {
      const subVariants = modelTempList
        .filter(
          (item) =>
            item.model === selectedModel && item.variant === selectedVariant
        )
        .map((item) => item.sub_variant)
        .filter((value, index, self) => self.indexOf(value) === index);

      setSubVariantList(subVariants);
      setSelectedSubVariant(""); // Reset sub-variant when variant changes
    } else {
      setSubVariantList([]);
      setSelectedSubVariant("");
    }
  }, [selectedModel, selectedVariant, modelTempList]);

  // Initialize form when request prop changes
  useEffect(() => {
    if (request?.model) {
      setselectedModel(request.model);

      // If we have request data, we need to ensure modelTempList is loaded
      if (modelTempList.length > 0) {
        const variants = modelTempList
          .filter((item) => item.model === request.model)
          .map((item) => item.variant)
          .filter((value, index, self) => self.indexOf(value) === index);

        setVariantList(variants);

        if (request.variant) {
          setSelectedVariant(request.variant);

          const subVariants = modelTempList
            .filter(
              (item) =>
                item.model === request.model && item.variant === request.variant
            )
            .map((item) => item.sub_variant)
            .filter((value, index, self) => self.indexOf(value) === index);

          setSubVariantList(subVariants);

          if (request.sub_variant) {
            setSelectedSubVariant(request.sub_variant);
          }
        }
      }
    } else {
      // Reset form if no request
      setselectedModel("");
      setSelectedVariant("");
      setSelectedSubVariant("");
    }
  }, [request, modelTempList]); // Added modelTempList to dependencies

  // useEffect(() => {
  //   fetchAllData();
  // }, []);
  // const fetchAllData = () => {
  //   axios({
  //     method: "get",
  //     url: VAVE + GETMODEL,
  //     withCredentials: false,
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     },
  //   })
  //     .then((res) => {
  //       const data = res.data.data;
  //       setModelTempList(data);

  //       const uniqueModels = data.filter(
  //         (obj, index, self) =>
  //           index === self.findIndex((t) => t.model === obj.model)
  //       );
  //       setModelList(uniqueModels);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching model data:", error);
  //     });
  // };

  // useEffect(() => {
  //   if (selectedModel) {
  //     const variants = modelTempList
  //       .filter((item) => item.model === selectedModel)
  //       .map((item) => item.variant)
  //       .filter((value, index, self) => self.indexOf(value) === index);

  //     setVariantList(variants);
  //     setSelectedVariant("");
  //     setSubVariantList([]);
  //     setSelectedSubVariant("");
  //   }
  // }, [selectedModel]);

  // useEffect(() => {
  //   if (request?.model) {
  //     setselectedModel(request.model);
  //     fetchAllData();
  //     if (selectedModel) {
  //       const variants = modelTempList
  //         .filter((item) => item.model === selectedModel)
  //         .map((item) => item.variant)
  //         .filter((value, index, self) => self.indexOf(value) === index);

  //       setVariantList(variants);
  //       setSelectedVariant("");
  //       setSubVariantList([]);
  //       setSelectedSubVariant("");
  //     }
  //   } else {
  //     setselectedModel("");
  //   }

  //   if (selectedVariant) {
  //     const subVariants = modelTempList
  //       .filter(
  //         (item) =>
  //           item.model === selectedModel && item.variant === selectedVariant
  //       )
  //       .map((item) => item.sub_variant)
  //       .filter((value, index, self) => self.indexOf(value) === index);

  //     setSubVariantList(subVariants);
  //     setSelectedSubVariant(""); // Reset sub-variant
  //   }
  // }, [request]);

  // useEffect(() => {
  //   if (selectedVariant) {
  //     const subVariants = modelTempList
  //       .filter(
  //         (item) =>
  //           item.model === selectedModel && item.variant === selectedVariant
  //       )
  //       .map((item) => item.sub_variant)
  //       .filter((value, index, self) => self.indexOf(value) === index);

  //     setSubVariantList(subVariants);
  //     setSelectedSubVariant(""); // Reset sub-variant
  //   }
  // }, [selectedVariant]);

  const numberToWords = (num) => {
    if (!num) return "";
    return toWords(Number(num)) + " rupees";
  };
  const currentEmpId = localStorage.getItem("empid");
  const handleSubmit = async (status) => {



    if (inputValue.trim() === "") {
      setOpenAlert(true);
      return;
    }


    if (sourcingEmpIds.includes(currentEmpId)) {

      if(status !== "parked"){

     
      if (savingsValue.trim() === "") {
        setOpenAlert(true);
        return;
      }
        if (isNegotiation.trim() === "") {
        setOpenAlert(true);
        return;
      }
       }
    }
    // For non-sourcing employees: validate matrix fields conditionally
    else {
   if(status !== "parked"){
    
      if (testingRequired.trim() === "") {
        setOpenAlert(true);
        return;
      }
    }
      // // If variant is selected, then sub-variant becomes mandatory
      // if (selectedVariant && !selectedSubVariant) {
      //   setOpenAlert(true);
      //   return;
      // }
    }

    const formData = new FormData();

    if (sourcingEmpIds.includes(currentEmpId)) {
      formData.append(
        "il1_sourcing_approve_id",
        localStorage.getItem("empid") || ""
      );
      formData.append(
        "il1_sourcing_assigned",
        localStorage.getItem("empname") || ""
      );
      formData.append(
        "il1_sourcing_approve",
        localStorage.getItem("empname") || ""
      );
      formData.append("il1_sourcing_comment", inputValue);
      formData.append("il1_sourcing_status", status);
      formData.append("il1_sourcing_savings", savingsValue);
      formData.append("is_negotiation", isNegotiation);
    } else {
      formData.append("il1_pd_approve_id", localStorage.getItem("empid") || "");
      formData.append("il1_pd_assigned", localStorage.getItem("empname") || "");
      formData.append("il1_pd_approve", localStorage.getItem("empname") || "");
      formData.append("il1_pd_comment", inputValue);
      formData.append("il1_pd_status", status);
      formData.append("il1_pd_testing_required", testingRequired);
      formData.append("il1_pd_model", selectedModel || "");
      formData.append("il1_pd_variant", selectedVariant || "");
      formData.append("il1_pd_subvariant", selectedSubVariant || "");
    }

    formData.append("idea", request?.idea ?? "");
    formData.append("ideaids", request?.id_x ?? "");
    // formData.append("empid", localStorage.getItem("empid") || "");

    try {
      setIsLoading(true);

      const url = sourcingEmpIds.includes(currentEmpId)
        ? IL1APPROVEBYSOURCING
        : IL1APPROVEBYPD;

      await axios.post(VAVE + url, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Submitted successfully!");
      // Optionally clear state or notify parent here
      setInputValue("");
      setSavingsValue("");

      setRefreshApi(true);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setOpenAlert(false);
      setRefreshApi(true);

      setIsLoading(false);
    }
  };
  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      <label
        htmlFor="comment"
        style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
      >
        Reason*
      </label>

      <TextField
        id="comment"
        placeholder="Enter comment"
        fullWidth
        required
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        size="small"
      />

      {sourcingEmpIds.includes(currentEmpId) ? (
        <>
          <label
            htmlFor="savings"
            style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
          >
            Wetted Savings*
          </label>
          <input
            type="text"
            id="savings"
            className="form-control"
            placeholder="Enter Savings"
            value={savingsValue}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setSavingsValue(value);
              }
            }}
            inputMode="numeric"
            required
          />
          {savingsValue && (
            <small
              style={{ color: "gray", marginTop: "5px", display: "block" }}
            >
              {numberToWords(savingsValue)}
            </small>
          )}


          <label
  htmlFor="matrix"
  style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
>
  Negotiation*
</label>

<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
  <label>
    <input
      type="radio"
      name="matrix"
      value="yes"
      onChange={() => setIsNegotiation("yes")}
    />{" "}
    Yes
  </label>
  <label>
    <input
      type="radio"
      name="matrix"
      value="no"
      onChange={() => setIsNegotiation("no")}
    />{" "}
    No
  </label>
</div>
        </>




      ) : (
        <>
       <label
  htmlFor="matrix"
  style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
>
  Testing Required*
</label>

<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
  <label>
    <input
      type="radio"
      name="matrix"
      value="yes"
      onChange={() => setTestingRequired("yes")}
    />{" "}
    Yes
  </label>
  <label>
    <input
      type="radio"
      name="matrix"
      value="no"
      onChange={() => setTestingRequired("no")}
    />{" "}
    No
  </label>
</div>

          <label
            htmlFor="matrix"
            style={{ display: "block", marginBottom: 8, marginLeft: 0 }}
          >
            Applicable Matrix
          </label>
          <div className="row mb-4">
            <div className="row">
              {/* Model Dropdown */}
              <div className="col-md-4">
                <label htmlFor="model">Model</label>
                <select
                  id="model"
                  value={selectedModel}
                  onChange={(e) => setselectedModel(e.target.value)}
                  className="form-control"
                  required
                >
                  <option value="">-- Select Model --</option>
                  {modelList.map((item, index) => (
                    <option key={index} value={item.model}>
                      {item.model}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="variant">
                  {selectedModel} Variant
                </label>
                <select
                  id="variant"
                  value={selectedVariant}
                  onChange={(e) => setSelectedVariant(e.target.value)}
                  className="form-control"
                  required={!!selectedModel}
                  disabled={!selectedModel}
                >
                  <option value="">-- Select Variant --</option>
                  {variantList.map((variant, index) => (
                    <option key={index} value={variant}>
                      {variant}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label htmlFor="subvariant">
                  {selectedVariant} Sub-Variant
                </label>
                <div
                  id="subvariant"
                  className="form-control"
                  style={{ border: "none" }}
                >
                  {subVariantList.map((sub, index) => (
                    <div key={index}>
                      <input
                        type="checkbox"
                        id={`sub-${index}`}
                        value={sub}
                        checked={selectedSubVariant.includes(sub)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (e.target.checked) {
                            setSelectedSubVariant([
                              ...selectedSubVariant,
                              value,
                            ]);
                          } else {
                            setSelectedSubVariant(
                              selectedSubVariant.filter(
                                (item) => item !== value
                              )
                            );
                          }
                        }}
                        disabled={!selectedVariant}
                      />
                      <label htmlFor={`sub-${index}`}>{sub}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleSubmit("accepted")}
          style={{ marginRight: "10px" }}
          disabled={isLoading}
        >
          Accept
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={() => handleSubmit("rejected")}
          disabled={isLoading}
        >
          Reject
        </Button>
        <Button
  variant="outlined"
  color="warning"
  style={{ marginLeft: "10px" }}
  onClick={() => handleSubmit("parked")}
  disabled={isLoading}
>
  Parked
</Button>
      </div>

      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>
         Please fill in all the mandatory fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialogForm;
